import usePrivateAxios from '@/common/api/usePrivateAxios'
import { ProductNfceMappingValidationSchema } from '@/features/productNfceMappings/schemas/create.schema'
import { useMutation } from '@tanstack/react-query'
import { AxiosError, AxiosResponse } from 'axios'

interface UseCreateProductNfceMappingProps {
  onSuccess?: (response: AxiosResponse) => void
  onError?: (error: AxiosError) => void
}

export const useCreateProductNfceMapping = ({ onSuccess, onError }: UseCreateProductNfceMappingProps) => {
  const privateAxios = usePrivateAxios()

  return useMutation({
    mutationKey: ['createProductNfceMapping'],
    mutationFn: async (form: ProductNfceMappingValidationSchema) => {
      const product_nfce_mapping = {
        name: form.name,
        product_id: form.product_id.value,
      }

      return await privateAxios.post('/product_nfce_mappings', { product_nfce_mapping })
    },
    onSuccess,
    onError,
  })
}
